import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useContext } from "react";

import { ApiTokenContext } from "@/contexts/api-token/ApiContextWrapper";
import { createNavigationProps } from "@/utils/common";
import {
  DASHBOARD_MENU_ITEM,
  GET_STARTED_MENU_ITEM,
  LOGIN_MENU_ITEM,
  LOGOUT_MENU_ITEM,
  MAIN_MENU_ITEMS,
} from "@/utils/constants/menu";
import "./SideBarComponent.css";

function AutoSideBar() {
  const { token, logout } = useContext(ApiTokenContext),
    isLoggedIn = Boolean(token);

  return (
    <IonMenu contentId="main-content" className="mfp-main-sidebar">
      <IonHeader>
        <IonToolbar>
          <IonTitle>Main Menu</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonList lines="none">
          <IonMenuToggle className="mfp-get-started" autoHide={false}>
            <IonItem
              button
              routerLink={
                (isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM)
                  .linkTo
              }
            >
              {(isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM)
                .icon && (
                <IonIcon
                  icon={
                    (isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM)
                      .icon
                  }
                  className="text-2xl text-blue-500"
                />
              )}
              <IonLabel>
                {
                  (isLoggedIn ? DASHBOARD_MENU_ITEM : GET_STARTED_MENU_ITEM)
                    .label
                }
              </IonLabel>
            </IonItem>
          </IonMenuToggle>
          <IonMenuToggle autoHide={false}>
            {isLoggedIn ? (
              <IonItem
                button
                routerLink={LOGOUT_MENU_ITEM.linkTo}
                onClick={() => logout()}
              >
                <IonIcon
                  icon={LOGOUT_MENU_ITEM.icon}
                  className="text-2xl text-blue-500"
                />
                <IonLabel>{LOGOUT_MENU_ITEM.label}</IonLabel>
              </IonItem>
            ) : (
              <IonItem button routerLink={LOGIN_MENU_ITEM.linkTo}>
                <IonIcon
                  icon={LOGIN_MENU_ITEM.icon}
                  className="text-2xl text-blue-500"
                />
                <IonLabel>{LOGIN_MENU_ITEM.label}</IonLabel>
              </IonItem>
            )}
          </IonMenuToggle>
          <IonItemDivider />
          {MAIN_MENU_ITEMS.map((menuItem, idx) => (
            <IonMenuToggle autoHide={false} key={idx}>
              <IonItem button {...createNavigationProps(menuItem.linkTo)}>
                <IonIcon
                  icon={menuItem.icon}
                  className="text-2xl text-blue-500"
                />
                <IonLabel>{menuItem.label}</IonLabel>
              </IonItem>
            </IonMenuToggle>
          ))}
        </IonList>
      </IonContent>
    </IonMenu>
  );
}

export { AutoSideBar };
